"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("documentRequests").controller("DocumentRequestsCtrl", DocumentRequestsCtrl).component("documentRequests", {
    templateUrl: "app/pages/documentRequests/documentRequests.html",
    bindings: {
      resolve: "<?"
    },
    //transclude: true,
    controller: DocumentRequestsCtrl
  });

  function DocumentRequestsCtrl($rootScope, $scope, $timeout, $controller, moment, AgGridService, DocumentRequestsService, DamagesService) {
    var _this = this;

    var vm = this;

    var isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    var isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.ctrlName = "DocumentRequestsCtrl";

    vm.log = debug("pages:documentRequests");

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: DocumentRequestsService,
      params: {
        editPage: "documentRequests/documentRequest"
      }
    });

    vm.gridEvent = function (value) {
      if (value.type == "rowDoubleClicked") {
        vm.edit(value.data);
      }
    };

    vm.close = function () {
      console.log("$scope", $scope);
      if ($scope.$parent) {
        $scope.$parent.$close();
      }
    };

    vm.refresh = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var where, documentRequests, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, documentRequest;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context.prev = 1;

                vm.log("refresh documentRequests", params);

                if (params && params.from && params.to) {
                  vm.from = params.from;
                  vm.to = params.to;
                }

                if (!vm.from || !vm.to) {
                  vm.from = moment().subtract(12, "months").startOf("month").toDate();
                  vm.to = moment().endOf("month").toDate();
                }

                where = { creationDate: { $gte: vm.from, $lte: vm.to } };
                _context.next = 8;
                return DocumentRequestsService.load(null, false, null, where);

              case 8:
                documentRequests = _context.sent;


                vm.rawData = [];

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 13;
                for (_iterator = documentRequests[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  documentRequest = _step.value;

                  documentRequest.btEdit = {
                    text: '<i class="fa fa-edit"></i> Modifier',
                    color: "custom"
                  };
                  documentRequest.btDelete = {
                    text: '<i class="fa fa-trash"></i> Suppr.',
                    color: "custom-danger"
                  };
                  documentRequest.btLink = {
                    text: '<i class="fa fa-paper-plane"></i> Renvoyer',
                    color: "custom"
                  };

                  try {
                    vm.rawData.push(documentRequest);
                  } catch (error) {
                    console.error(error);

                    Notiflix.Notify.failure("Une erreur est survenue sur l'object :" + documentRequest._id);
                  }
                }

                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                Notiflix.Loading.remove();

                $timeout(function () {
                  _this.needToBeUpdate = true;
                });
                _context.next = 38;
                break;

              case 33:
                _context.prev = 33;
                _context.t1 = _context["catch"](1);

                Notiflix.Notify.failure("Une erreur est survenue au chargement des données");

                console.error(_context.t1);
                Notiflix.Loading.remove();

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 33], [13, 17, 21, 29], [22,, 24, 28]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    vm.email = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var confirmSend, allowSave, phone, emailRegex;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("need to send reminder email", row);

                _context2.next = 3;
                return swal({
                  //title: "",
                  text: "Confirmez-vous le renvoi de la demande ?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "Non",
                    confirm: "Oui"
                  }
                });

              case 3:
                confirmSend = _context2.sent;
                allowSave = true;


                if (row.phone) {
                  phone = row.phone.replace(/[\s.\-()]/g, "");

                  if (/^00[1-9]\d{6,13}$/.test(phone)) {
                    phone = "+" + phone.slice(2);
                  } else if (/^0\d{9}$/.test(phone)) {
                    phone = "+33" + phone.slice(1);
                  }
                  if (/^\+[1-9]\d{6,14}$/.test(phone)) {
                    row.phone = phone;
                  } else {
                    Notiflix.Notify.failure("Le format du portable n'est pas valide");
                    allowSave = false;
                  }
                }

                emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (row.email && !emailRegex.test(row.email)) {
                  Notiflix.Notify.failure("La format de l'email n'est pas valide");
                  allowSave = false;
                }

                if (!(confirmSend && allowSave)) {
                  _context2.next = 21;
                  break;
                }

                Notiflix.Loading.standard("Envoi en cours ...<br>Veuillez patienter");

                _context2.prev = 10;
                _context2.next = 13;
                return DamagesService.customPost("documentRequest/" + row._id, {
                  _id: row._id
                });

              case 13:

                Notiflix.Notify.success("La demande de documents a été renvoyée");
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](10);

                console.error(_context2.t0);
                Notiflix.Notify.failure("Une erreur est survenue lors de l'envoi de la demande");

              case 20:

                Notiflix.Loading.remove();

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[10, 16]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.delete = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var deleteDoc;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return swal({
                  title: "Voulez-vous supprimer cette demande de documents pour " + row.contactName + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 2:
                deleteDoc = _context3.sent;

                if (!deleteDoc) {
                  _context3.next = 7;
                  break;
                }

                console.log("need to delete this doc", row);
                _context3.next = 7;
                return DocumentRequestsService.deleteById(row._id).then(function () {
                  Notiflix.Notify.success("La suppression a réussi");
                  vm.refresh();
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    var displayWriteBt = isAdmin || isSuper || $rootScope.$user.rights && $rootScope.$user.rights.damage && $rootScope.$user.rights.damage.write && $rootScope.$user.rights.damage.write === true;
    var displayDeleteBt = isAdmin || $rootScope.$user.rights && $rootScope.$user.rights.damage && $rootScope.$user.rights.damage.delete && $rootScope.$user.rights.damage.delete === true;

    if (displayWriteBt !== true) {
      vm.edit = null;
    }

    vm.columnDefs = [AgGridService.date("creationDate", "Date de création"), AgGridService.text("targetName", "Pour"), AgGridService.text("contactName", "Nom du contact"), AgGridService.text("email", "Email"), AgGridService.date("lastEmailDate", "Date Email"), AgGridService.text("phone", "Portable"), AgGridService.date("lastSmsDate", "Date SMS")];

    if (displayWriteBt || displayDeleteBt) {
      var adminColumns = [];
      if (displayWriteBt) {
        adminColumns.push(AgGridService.button("btEdit", "Modifier", vm.edit, this, {
          width: 90
        }), AgGridService.button("btLink", "Demande", vm.email, this, {
          width: 90
        }));
      }
      if (displayDeleteBt && displayWriteBt) {
        adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
          width: 80,
          columnGroupShow: "open"
        }));
      } else if (displayDeleteBt) {
        adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
          width: 90
        }));
      }
      var adminGroup = AgGridService.group("Admin", adminColumns);
      vm.columnDefs.unshift(adminGroup);
    }

    vm.refresh();
  }
})();